import { Box, Stack, styled, Typography } from '@mui/material'
import { Outlet, Route, Routes, useNavigate } from 'react-router-dom'
import { useFetchAuthenticatedUser } from 'hooks/use-authenticated-user'
import Impersonate from './Impersonate'
import { useEffect } from 'react'
import SubpageTabs, { SubpageTabLink } from 'components/SubpageTabs'
import AccountManagement from './AccountManagement'
import AdminMetrics from './AdminMetrics'
import AIMetrics from './AIMetrics'
import TwinMetrics from './TwinMetrics'
import TwinPrompts from './TwinPrompts'
import useCheckMobileScreen from 'hooks/use-check-mobile-screen'
import { COLORS } from 'app-constants'
import Waitlist from './Waitlist'

const MainBox = styled(Box)`
  width: 100%;
  height: 100vh;
`

const AdminContainer = () => {
  const isMobile = useCheckMobileScreen()

  if (isMobile) {
    return (
      <MainBox
        sx={{
          p: 3,
        }}>
        <Outlet />
      </MainBox>
    )
  }

  return (
    <Stack
      sx={{
        background: COLORS.PURE_WHITE,
        height: '100vh',
      }}>
      <Stack direction="row" justifyContent="flex-start">
        <Stack p={isMobile ? 2 : 3}>
          <Typography variant="h4" mb="49px">
            Admin (internal use)
          </Typography>
          <SubpageTabs>
            <SubpageTabLink to="/admin" label="Customer account access" />
            <SubpageTabLink to="/admin/accounts" label="Account management" />
            <SubpageTabLink to="/admin/metrics" label="App metrics" />
            <SubpageTabLink to="/admin/ai-metrics" label="AI metrics" />
            <SubpageTabLink to="/admin/twin-metrics" label="Twin metrics" />
            <SubpageTabLink to="/admin/prompts" label="Prompts" />
            <SubpageTabLink to="/admin/waitlist" label="Waitlist" />
          </SubpageTabs>
        </Stack>

        <MainBox
          sx={{
            borderLeft: '1px solid #ddd',
            p: 3,
            background: COLORS.GRAY_8,
          }}>
          <Outlet />
        </MainBox>
      </Stack>
    </Stack>
  )
}

const Admin = () => {
  const { user } = useFetchAuthenticatedUser()
  const navigate = useNavigate()

  useEffect(() => {
    if (!user?.is_system_admin) {
      navigate('/', { replace: true })
    }
  })

  return (
    <Routes>
      <Route element={<AdminContainer />}>
        <Route index element={<Impersonate />} />
        <Route path="/accounts" element={<AccountManagement />} />
        <Route path="/metrics" element={<AdminMetrics />} />
        <Route path="/ai-metrics" element={<AIMetrics />} />
        <Route path="/twin-metrics" element={<TwinMetrics />} />
        <Route path="/prompts" element={<TwinPrompts />} />
        <Route path="/waitlist" element={<Waitlist />} />
      </Route>
    </Routes>
  )
}

export default Admin
